export default __webpack_public_path__ + "static/james-headshot-3f9204c17796f9035d037652d73f48c5.jpg";